import React, { useState } from 'react';
import { Container } from '@mui/material';
import CreditDebitTrackerList from '../components/CreditDebitTrackerList';
import CreditDebitTrackerForm from '../components/CreditDebitTrackerForm';
import { CreditDebitTracker } from '../types/credit-debit-tracker.types';

const CreditDebitTrackerPage: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedCreditDebitTracker, setSelectedCreditDebitTracker] = useState<CreditDebitTracker | null>(null);
  const [formMode, setFormMode] = useState<'add' | 'edit'>('add');

  const handleAdd = () => {
    setSelectedCreditDebitTracker(null);
    setFormMode('add');
    setIsFormOpen(true);
  };

  const handleEdit = (creditDebitTracker: CreditDebitTracker) => {
    setSelectedCreditDebitTracker(creditDebitTracker);
    setFormMode('edit');
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
    setSelectedCreditDebitTracker(null);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <CreditDebitTrackerList
        onAdd={handleAdd}
        onEdit={handleEdit}
      />
      
      <CreditDebitTrackerForm
        open={isFormOpen}
        onClose={handleCloseForm}
        creditDebitTracker={selectedCreditDebitTracker}
        mode={formMode}
      />
    </Container>
  );
};

export default CreditDebitTrackerPage;
